import { useSettingsStore } from '../stores/settings';

let softAudio: HTMLAudioElement | null = null;
let firmAudio: HTMLAudioElement | null = null;

function play(intensity: 'soft' | 'firm') {
  const enabled = useSettingsStore.getState().settings.sound_enabled;
  if (!enabled) return;
  try {
    if (intensity === 'soft') {
      if (!softAudio) softAudio = new Audio('/sounds/soft.mp3');
      void softAudio.play().catch(() => {});
    } else {
      if (!firmAudio) firmAudio = new Audio('/sounds/firm.mp3');
      void firmAudio.play().catch(() => {});
    }
  } catch { /* ignore */ }
}

export const sounds = {
  soft: () => play('soft'),
  firm: () => play('firm'),
};
